import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a07bb174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vidoe_embed" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "embed_line" }, null, -1))
const _hoisted_3 = { class: "embed_line" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "embed_line_title" }, "屏幕宽：", -1))
const _hoisted_5 = { class: "embed_line" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "embed_line_title" }, "屏幕高：", -1))
const _hoisted_7 = { class: "text_line" }
const _hoisted_8 = { class: "text_line_svg" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "屏幕默认宽高比为16:9，调整大小将按照此比列缩放 ；"),
  /*#__PURE__*/_createElementVNode("p", null, "播放器外嵌观看并发量或观看时长，同等消耗账户资源。")
], -1))
const _hoisted_10 = { class: "code_line" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "embed_line_title" }, "嵌入代码：", -1))
const _hoisted_12 = { class: "code_line_box" }
const _hoisted_13 = { class: "code_line_text" }
const _hoisted_14 = ["data-clipboard-text"]
const _hoisted_15 = { class: "pull_box" }
const _hoisted_16 = { class: "pull_box_con" }
const _hoisted_17 = ["id", "data-clipboard-text", "onClick"]
const _hoisted_18 = { class: "text_line" }
const _hoisted_19 = { class: "text_line_svg" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "外链拉流将消耗此账号并发资源", -1))
const _hoisted_21 = ["data-clipboard-text"]

import { computed, reactive, ref, watch } from 'vue';
import { Radio, InputNumber, message } from 'ant-design-vue';
import { InfoCircleFilled, ReloadOutlined } from '@ant-design/icons-vue';
import ClipboardJS from 'clipboard';
import { useLiveStore } from '@/pinia/live';
import { useRoute } from 'vue-router';
import api from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoeEmbed',
  setup(__props) {

const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;

const liveStore = useLiveStore();
const route = useRoute();
const value = ref<number>(3);
const size = reactive({
  width: 400,
  height: 225,
});

const getHeight = () => {
  const width = size.width;
  const height = computed(() => Math.round((width / 16) * 9));
  size.height = height.value;
};

const getWidth = () => {
  const height = size.height;
  const width = computed(() => Math.round((height / 9) * 16));
  size.width = width.value;
};

const clipboardText = ref('');
const urlArr = ref<any>([]);
const init = () => {
  if (!liveStore.liveInfo.play_url) return;
  clipboardText.value =
    `rtmp：${liveStore.liveInfo.play_url[0]}\n` +
    `m3u8：${liveStore.liveInfo.play_url[2]}\n` +
    `flv：${liveStore.liveInfo.play_url[1]}\n`;

  urlArr.value = [
    { name: 'rtmp', url: liveStore.liveInfo.play_url[0], id: 'warrant1' },
    { name: 'm3u8', url: liveStore.liveInfo.play_url[2], id: 'warrant2' },
    { name: 'flv', url: liveStore.liveInfo.play_url[1], id: 'warrant3' },
  ];
};
init();
watch(
  () => liveStore.liveInfo.play_url,
  (newVal) => {
    if (!newVal) return;
    clipboardText.value = `rtmp：${newVal[0]}\n` + `m3u8：${newVal[2]}\n` + `flv：${newVal[1]}\n`;
    urlArr.value = [
      { name: 'rtmp', url: newVal[0], id: 'warrant1' },
      { name: 'm3u8', url: newVal[2], id: 'warrant2' },
      { name: 'flv', url: newVal[1], id: 'warrant3' },
    ];
  }
);

const Copylist = (btns: string) => {
  text.value = copyTextRef.value.textContent;
  console.log(copyTextRef.value.innerText);

  let ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

const copyTextRef = ref();
const text = ref();
const clickRefresh = () => {
  api.live
    .refreshPushPlay({ studio_id: liveStore.liveInfo.id })
    .then((res) => {
      const resourceData = res.data.data.play_url;
      liveStore.liveInfo.play_url = [resourceData[0], resourceData[2], resourceData[1]];
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(aInputNumber), {
          disabled: value.value === 2,
          value: size.width,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((size.width) = $event)),
          min: 16,
          onChange: getHeight
        }, null, 8, ["disabled", "value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(aInputNumber), {
          disabled: value.value === 2,
          value: size.height,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((size.height) = $event)),
          min: 9,
          onChange: getWidth
        }, null, 8, ["disabled", "value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(InfoCircleFilled))
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("pre", null, [
              _createElementVNode("code", {
                ref_key: "copyTextRef",
                ref: copyTextRef
              }, "<iframe\n src=\"https://live.qingtv.com/event/" + _toDisplayString(_unref(route).params.studioId) + "?player\"\n style=\"width:" + _toDisplayString(size.width) + "px; height:" + _toDisplayString(size.height) + "px; overflow:hidden\"\n scrolling=\"no\"\n allowFullScreen\n ></iframe>", 513),
              _createTextVNode("\n            ")
            ])
          ]),
          _createElementVNode("div", {
            class: "code_line_copy code_copy",
            "data-clipboard-text": text.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (Copylist('.code_copy')))
          }, "一键复制", 8, _hoisted_14)
        ])
      ])
    ], 512), [
      [_vShow, value.value != 3]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urlArr.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "pull_box_con_line",
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(item.name) + "：", 1),
              _createVNode(_component_a_input, {
                value: item.url,
                "onUpdate:value": ($event: any) => ((item.url) = $event),
                readonly: "",
                class: "copy_text"
              }, {
                addonAfter: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "copy_btn",
                    id: item.id,
                    "data-clipboard-text": item.url,
                    onClick: ($event: any) => (Copylist(`#${item.id}`))
                  }, [
                    _createVNode(_component_svg_icon, { "icon-class": "live_url_copy" })
                  ], 8, _hoisted_17)
                ]),
                _: 2
              }, 1032, ["value", "onUpdate:value"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_unref(InfoCircleFilled))
            ]),
            _hoisted_20
          ])
        ]),
        _createElementVNode("div", {
          class: "code_line_copy all_copy",
          "data-clipboard-text": clipboardText.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (Copylist('.all_copy')))
        }, "全部复制", 8, _hoisted_21)
      ]),
      _createElementVNode("div", {
        class: "re_btn",
        onClick: clickRefresh
      }, [
        _createVNode(_component_a_button, { class: "btn" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ReloadOutlined)),
            _createTextVNode("刷新")
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, value.value === 3]
    ])
  ]))
}
}

})